// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2":"aaeb706adc2cf679","241":"d89eb6e4ee1d947c"}[chunkId] + ".css";
};